import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {trackerBabyDetailsFetch} from '../../../../actions/index';
import cx from '../../../../styles';
import Loader from '../../../../components/Common/Loader';
import BaseLayout from '../../../../components/Layout/BaseLayout';
import AdCoreSlot from '../../../../components/Ads/AdCoreSlot';
import BabyViewComponent from '../../../../components/Tracker/BabyView';
import Breadcrumbs from '../../../../components/Layout/Breadcrumbs';
import Template404Container from '../../../404';
import { translate } from 'react-i18next';

class BabyViewContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isDataEmpty: false
        };
    }

    componentDidMount() {
        if(this.props.match.params.month !== this.props.trackerReducer.babyMonth) {
            this.props.trackerBabyDetailsFetch(this.props.match.params.month)
            .then((response) => {
                if(!(response && response.status)){
                    this.setState({isDataEmpty: true});
                }
            });
        }
        //scroll fix
        window.scrollTo(0,0);
    }

    componentWillReceiveProps(nextProps) {
        if((nextProps.location.pathname !== this.props.location.pathname)) {
            //scroll fix
            window.scrollTo(0,0);
            this.props.trackerBabyDetailsFetch(nextProps.match.params.month);
        }
    }

    buildRightSidebar = () => {
        const ads = this.props.configReducer.ads;
        const rc = [
            <div className={cx("shadow-card")}>
                <a href="https://community.theasianparent.com/app/download?utm_source=community-static-banner&utm_medium=web&utm_campaign=app-download">
                    <img src={this.props.configReducer['region'].staticAd1} alt="TAPApps_launch" loading="lazy"/>
                </a>
            </div>,
            ads.networkId &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
        ];

        return rc;
    }

    render(){
        const lc = [], rc = this.buildRightSidebar();
        const {history, match, landingUrl, serverReqCookie, t, trackerReducer, appReducer, location} = this.props;

        if(this.state.isDataEmpty){
            return (
                <Template404Container history={history} match={match} />
            );
        }
        else{
            return (

                <BaseLayout 
                    history={history} 
                    match={match}
                    landingUrl={landingUrl}
                    serverReqCookie={serverReqCookie}
                    leftCards={lc} rightCards={rc} 
                >
                    { 
                        trackerReducer.babyViewContent && trackerReducer.babyViewContent.month &&
                        <BabyViewComponent data={trackerReducer.babyViewContent.month} locale={appReducer.locale} t={t}/>
                    }

                    { trackerReducer.isLoading && <Loader /> }

                    <Breadcrumbs links={[
                            {location: '/feed', label: 'Home'},
                            {location: '/tracker', label: 'Tracker'},
                            {location: '/tracker/baby', label: 'Baby'},
                            {location: location.pathname, label: trackerReducer.babyViewContent && trackerReducer.babyViewContent.month && trackerReducer.babyViewContent.month.heading},

                        ]} /> 
                </BaseLayout>
            );
        }
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        trackerBabyDetailsFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(BabyViewContainer));
